'use client';

import AdSense from './AdSense';
import type { CSSProperties } from 'react';

interface NewsCardAdProps {
  country?: string;
  className?: string;
}

// Country-specific ad slots for location-based ad serving
const countryAdSlots: Record<string, string> = {
  'IN': '1234567890', // India
  'US': '1234567891', // United States
  'GB': '1234567892', // United Kingdom
  'SG': '1234567893', // Singapore
  'AE': '1234567894', // UAE
  'NO': '1234567895', // Norway
  'IE': '1234567896', // Ireland
  'WORLD': '1234567897', // Default/World
};

const NewsCardAd: React.FC<NewsCardAdProps> = ({ 
  country = 'WORLD',
  className = '' 
}) => {
  const adSlot = countryAdSlots[country] || countryAdSlots['WORLD'];
  
  const containerStyle: CSSProperties = {
    width: '100%',
    minHeight: '250px',
    display: 'block',
    overflow: 'hidden',
  };

  return (
    <div 
      className={`ad-container bg-card rounded-md border border-border overflow-hidden ${className}`}
      style={containerStyle}
    >
      <div className="p-2 text-center text-xs text-muted-foreground border-b border-border">
        Advertisement
      </div>
      <AdSense
        adClient={process.env.NEXT_PUBLIC_ADSENSE_ID || ''}
        adSlot={adSlot}
        adFormat="auto"
        country={country}
        adStyle={{
          width: '100%',
          height: 'auto',
          display: 'block',
          minHeight: '200px'
        }}
      />
    </div>
  );
};

export default NewsCardAd;